module.exports = __webpack_public_path__ + "media/images/goutte-tablet-bda9f27a6fd93014652a1dbebbac1267.jpg";